// extracted by mini-css-extract-plugin
export default {"messageContainer":"ZIHfdlDISwWsjgy30IVz","messageType":"LS_kWZQXOW3HWc00HYQ7","outgoing":"qys7xlFwafQKHNcxj83L"};